import AutocompleteField from "../../../Form/AutocompleteField";
import { LANGUAGES_TIKTOK_OPTIONS } from "../../../../utils/catalogs/languageOptions";

const SelectLanguagesTikTokForm = ({
  name,
  control,
  errors,
  sx = {},
  disabled = false,
}) => {
  return (
    <AutocompleteField
      name={name}
      control={control}
      errors={errors}
      options={LANGUAGES_TIKTOK_OPTIONS}
      doTranslate={true}
      fullWidth
      multiple={true}
      sx={sx}
      disabled={disabled}
    />
  );
};

export default SelectLanguagesTikTokForm;
